import React from "react";
import { showLocalDate, tolocalDate } from "../../../utilities/functions";

const LocallyDate = ({ row }) => {
  return <div>{row.startDate ? showLocalDate(row.startDate) : ""}</div>;
};

export default LocallyDate;
